module.exports = __webpack_public_path__ + "4ed905c532b443ae93164a6ffd2f5af1.svg";